import React, { useState } from "react";
import HttpsOutlinedIcon from "@mui/icons-material/HttpsOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const SignUp = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [inputType, setInputType] = useState("password");
  const [loader, setLoader] = useState(false);
  const togglePassword = () => {
    setInputType(inputType === "password" ? "text" : "password");
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  let name, value;
  const handleChange = (event) => {
    event.preventDefault();
    name = event.target.name;
    value = event.target.value;
    setFormData({ ...formData, [name]: value });
  };

  const validateEmail = (input) => {
    const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return emailRegex.test(input);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { name, email, password } = formData;
    if (!name || !email || !password) {
      toast.error("Please fill all fields!");
    } else if (!validateEmail(email)) {
      toast.error("Email Address is not invalid!");
    } else {
      setLoader(true);
      try {
        const response = await axios.post(`${apiUrl}authAddUser`, formData);
        const data = await response.data;
        if (data) {
          navigate("/admin/login");
          toast.success("Account created successfully!");
        } else {
          toast.error("Account creation failed!");
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        console.error(error);
        toast.error("Something went wrong!");
      }
    }
  };

  return (
    <div class="dashboard-login w-full h-full bg-[#FAFBFB] flex items-center justify-center flex-col gap-5">
      <ToastContainer />
      <div className="bg-blue-600 rounded-full h-11 w-11 text-white flex justify-center items-center">
        <HttpsOutlinedIcon sx={{ fontSize: "21px" }} />
      </div>
      <div className="text-center">
        <h1 className="font-bold text-[18px]">Sign Up</h1>
        <p className="text-sm opacity-70 mt-1">Create an admin account</p>
      </div>
      <form method="post" action="#" className="bg-white w-[40%] p-10">
        <div class="form-group mb-5">
          <label className="text-sm mb-2 pl-1 block">Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            placeholder="John Doe"
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        <div class="form-group mb-5">
          <label className="text-sm mb-2 pl-1 block">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="e.g: john@gmail.com"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div class="form-group mb-4">
          <label className="text-sm mb-2 pl-1 block">Password</label>
          <input
            type={inputType}
            name="password"
            className="form-control"
            placeholder="Enter Password"
            value={formData.password}
            onChange={handleChange}
          />
          <div className="togglePasswordIcon" onClick={togglePassword}>
            <span className="cursor-pointer text-gray-400">
              {inputType === "password" ? (
                <VisibilityOffOutlinedIcon sx={{ fontSize: "17px" }} />
              ) : (
                <VisibilityOutlinedIcon sx={{ fontSize: "17px" }} />
              )}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="primary-bg shadow-lg px-6 py-3 text-sm rounded-lg text-white uppercase mt-7 w-full flex items-center justify-center"
          onClick={handleSubmit}
        >
          Create Admin User
          <LoginOutlinedIcon sx={{ marginLeft: "15px", fontSize: "20px" }} />
        </button>

        {loader && (
          <div className="loader-container">
            <div className="loader text-sm text-gray-400 text-center block">Request is in process please wait....</div>
          </div>
        )}
      </form>
    </div>
  );
};

export default SignUp;
